import 'core-js';
import 'raf/polyfill';

import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
//import registerServiceWorker from './registerServiceWorker';
import {unregister} from './registerServiceWorker';
import QueryString from "query-string";
import {Calculator} from "./Calculator";
import {Constants} from "./Constants";

const VERSION = 1.0;

const parsed = QueryString.parse(window.location.search);
let inputData = {};

inputData.flow = getValidFlow(parsed);
inputData.inletPressure = getValidInletPressure(parsed);
inputData.outletPressure = getValidOutletPressure(parsed);
inputData.valveDimension = getValidValveDimension(parsed);
inputData.valveBore = getValidValveBore(parsed);
inputData.description = getValidDescription(parsed);

let location = getValidLocation(parsed);

ReactDOM.render(<App inputData={inputData} location={location} version={VERSION}/>, document.getElementById('root'));
//registerServiceWorker();
unregister();


function cap(value) {
    if (value < 0) {
        return 0;
    }
    return value;
}

function getValidFlow(p) {
    return cap(Number(p.fl) || Constants.defaultFlow);
}

function getValidInletPressure(p) {
    return cap(Number(p.ip) || Constants.defaultInletPressure);
}

function getValidOutletPressure(p) {
    return cap(Number(p.op) || Constants.defaultOutletPressure);
}

function getValidValveDimension(p) {
    let readValveDimension = Number(p.vd) || Constants.defaultValveDimension;
    return getClosestValveDimension(readValveDimension);
}

function getClosestValveDimension(valveDimension) {
    let shortestDistance = 1000;
    let selectedDimension = Constants.defaultValveDimension;
    for (const testDimension in Calculator.kvValues[0]) {
        let distance = valveDimension - testDimension;
        if (distance < 0) {
            distance = distance * -1
        }
        if (distance < shortestDistance) {
            shortestDistance = distance;
            selectedDimension = testDimension;
        }
    }
    return Number(selectedDimension);
}

function getValidValveBore(p) {
    const def = Constants.defaultValveBore;
    let readValveBore = Number(p.vb) || def;
    if (readValveBore !== 0 && readValveBore !== 1) {
        return def;
    }
    return readValveBore;
}

function getValidDescription(p) {
    return p.xd || Constants.defaultDescription;

}

function getValidLocation(p) {
    return Number(p.loc) || Constants.defaultLocation;

}